import type { HTMLAttributes, ReactNode } from 'react';
import { AImageProps } from '../../atoms/AImage/AImage.types';
import { AIconProps } from '../../atoms/AIcon/AIcon.types';
import { ABodyProps } from '../../atoms/ABody/ABody.types';
import { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';

export enum MAccordionItemType {
  Icon = 'Icon',
  Image = 'Image',
}

export type MAccordionItemProps = HTMLAttributes<HTMLDivElement> & {
  type?: MAccordionItemType;
  expanded?: boolean;
  aImage?: Partial<AImageProps>;
  aIcon?: Partial<AIconProps>;
  aBody?: Partial<ABodyProps>;
  aSubheader?: Partial<ASubheaderProps>;
  onToggle?: () => void;
  children?: ReactNode;
};
